import { render, staticRenderFns } from "./SiparisDetayButton.vue?vue&type=template&id=6a7e3b86&"
import script from "./SiparisDetayButton.vue?vue&type=script&lang=js&"
export * from "./SiparisDetayButton.vue?vue&type=script&lang=js&"
import style0 from "./SiparisDetayButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports